import { Router } from 'components';
import { AuthProvider, ThemeProvider } from 'contexts';

const App = () => (
  <ThemeProvider>
    <AuthProvider>
      <Router />
    </AuthProvider>
  </ThemeProvider>
);

export default App;
